import React, { ReactNode } from 'react'
import { Box } from 'transfix-ui/core'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { AlertCarrierNotConnected, AlertTruckNumberMissing } from '../load-details/alerts'

export interface IFMSELDError {
  message?: ReactNode
}

export const FMS_ELD_ERRORS: Record<string, IFMSELDError> = {
  /**
   * KeepTruckin
   */
  keepTruckinCarrierNotConnected: {
    message: <AlertCarrierNotConnected trackingMethod={TRACKING_METHOD_TYPE.keepTruckin} />,
  },
  keepTruckinTruckNotEntered: {
    message: <AlertTruckNumberMissing trackingMethod={TRACKING_METHOD_TYPE.keepTruckin} />,
  },
  keepTruckinTruckNotFound: {
    message: (
      <Box component='span' data-test='alert-keep-trucking-truck-not-found'>
        <strong>This truck can’t track via ELD.</strong> Your truck either wasn’t found in your
        KeepTruckin account or isn&apos;t connected to an ELD device.
      </Box>
    ),
  },
  /**
   * Project44
   */
  p44CarrierNotConnected: {
    message: <AlertCarrierNotConnected trackingMethod={TRACKING_METHOD_TYPE.project44} />,
  },
  p44TruckNotEntered: {
    message: <AlertTruckNumberMissing trackingMethod={TRACKING_METHOD_TYPE.project44} />,
  },
  p44TruckNotFound: {
    message: (
      <Box component='span' data-test='alert-p44-truck-not-found '>
        <strong>This truck can’t track via ELD.</strong> Your truck either wasn’t found in your
        Project44 account or isn’t connected to an ELD device.
      </Box>
    ),
  },
}

export type TELDErrorKey = keyof typeof FMS_ELD_ERRORS
